import { render, staticRenderFns } from "./number-text-field.vue?vue&type=template&id=df9f3314&scoped=true&"
import script from "./number-text-field.vue?vue&type=script&lang=js&"
export * from "./number-text-field.vue?vue&type=script&lang=js&"
import style0 from "./number-text-field.vue?vue&type=style&index=0&id=df9f3314&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9f3314",
  null
  
)

export default component.exports